/**
 * Gets the portal url to redirect
 * @returns a url
 */
export function getProductPartnerPortal(appRefName: string, country: string) {
  let portal_url = "";
  switch (appRefName) {
    case "GPS":
      switch (country) {
        case "Brazil":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_GPS_BRASIL ?? "";
          break;
        case "Argentina":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_GPS_ARGENTINA ?? "";
          break;
        case "Paraguay":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_GPS_PARAGUAY ?? "";
          break;
        case "Uruguay":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_GPS_URUGUAY ?? "";
          break;
        default:
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_GPS_BRASIL ?? "";
          break;
      }
      break;
    case "DCP":
      switch (country) {
        case "Canada":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_CARGILL_AG_CANADA ??
            "";
          break;
        case "United States":
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_CARGILL_AG_US ?? "";
          break;
        default:
          portal_url =
            process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_CARGILL_AG_US ?? "";
          break;
      }
      break;
    case "Australia":
      portal_url =
        process.env.NEXT_PUBLIC_REQUEST_ACCESS_REDIRECT_AUSTRALIA ?? "";
      break;
  }

  if (!portal_url) {
    throw new Error("Portal URL not set");
  }

  return portal_url;
}
